import React from 'react'
import {FaAlignJustify} from 'react-icons/fa'
import logo from "../assets/logo.png"
import PageLinks from "../constants/links"
import {animateScroll as scroll} from "react-scroll"

const navbar = ({toggleSidebar}) => {
    return (
        <nav className="navbar">
            <div className="nav-center">
                <div className="nav-header">
                    <img src={logo} alt="logo" onClick={()=> scroll.scrollToTop()}/>
                    <button type="button" className="toggle-btn" onClick={toggleSidebar}>
                        <FaAlignJustify></FaAlignJustify>
                    </button>
                </div>
                <PageLinks styleClass="nav-links"></PageLinks>
            </div>
        </nav>
    )
}


export default navbar